import { observer } from 'mobx-react';
import { useStores } from '@/hooks/useStores';
import Loader from '@/components/common/Loader';

const PageLoader = ({ children }: { children: React.JSX.Element }) => {
  const {
    authStore: { isInitializing, user },
  } = useStores();

  /* show loading indicator while the auth provider is still initializing */
  if (isInitializing || user.isLoading) {
    return <Loader />;
  }

  return <>{children}</>;
};

export default observer(PageLoader);
